import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { addBbpsPost, adddmtcomm, getbbpscommagId, getdmtcomm3, getdmtcommagId, getdmtcommscheme, getDmtCommSchemeID, getDmtCommSchemeNew, mainModuleList, relatedService, relatedService2, updateBbpscommagId, updatedmtcommagId , serviceMasterVendorforbbps } from '../../../api/login/Login';
import { ToastContainer, toast } from 'react-toastify';
import CustomInputField from '../../../common/CustomInputField';
import Breadcrumbs from '../../../common/breadcrumb/Breadcrumbs';
import { IoIosCloseCircleOutline } from "react-icons/io";

import Select from 'react-select'
import Loadar from '../../../common/loader/Loader';
function BbpsCommisionForm() {
    const [isFormValid, setIsFormValid] = useState(false);
    const [comboData, setcomboData] = useState(null);
    const params = useParams();
    const navigate = useNavigate();


    const [mainForms, setMainForms] = useState({
        name: '',
        service_id: '',
        isActive: false,
        commision_list: [
            {
                isDefault: true,
                slots: [
                    {
                        start_amt: '',
                        end_amt: '',
                        charge: '',
                        charge_type: '',
                        commision: '',
                        commision_type: '',
                        distributor_comm: '',
                        distributor_comm_type: '',
                        master_distributer_com: '',
                        master_distributer_com_type :'',
                        vendor_commission: [  
                            {
                              vendor_Id: '',
                              vendor_com: '',
                              vendor_com_type: '',
                              vendor_charge: '',
                              vendor_charge_type: ''
                            }
                          ]
                    }
                ]
            }
        ]
    });

    const [errors, setErrors] = useState({});

    const toastSuccessMessage = () => {
        toast.success(`${params?.id ? "Update" : "Add"} BBPS Commission Successfully.`, {
            position: "top-center",
        });
    };

    const toastErrorMessage = () => {
        toast.error(`${params?.id ? "Update" : "Add"} BBPS Commission Failed.`, {
            position: "top-center",
        });
    };

  

    const [loader , setLoader] = useState(false);

    const [formValues2, setFormValues2] = useState({
        name: '',
        service_id: '',
        isActive: false,
    });
  

    const addMore = (index) => {
        const clone = { ...mainForms }
        clone.commision_list[index].slots.push({
          start_amt: '',
          end_amt: '',
          charge: '',
          charge_type: '',
          commision: '',
          commision_type: '',
          distributor_comm: '',
          distributor_comm_type: '',
          master_distributer_com: '',
          master_distributer_com_type : "",
          vendor_commission: [
            {
              vendor_Id: '',
              vendor_com: '',
              vendor_com_type: '',
              vendor_charge: '',
              vendor_charge_type: ''
            }
          ]
        });
        setMainForms(clone);
      };
      

    // const addMore = (index) => {
    //     const clone = { ...mainForms }
    //     clone.commision_list[index].slots.push({ start_amt: '', end_amt: '', charge: '', charge_type: '', commision: '', commision_type: '', distributor_comm: '', distributor_comm_type: '', master_distributer_com: '' })
    //     console.log(clone);
    //     setMainForms(clone);
    // };
    const getSchCombo = async () => {
        try {
            const comboRes = await getdmtcommscheme();
            setcomboData(comboRes?.data);
        } catch (error) {
            alert(error.message)
        }
    };
    const [stateServices, stateSetServices] = useState([]);
    const getDMTid = async () => {
        try {
            const res = await getDmtCommSchemeNew()
            stateSetServices(res?.data);
        } catch (error) {
            alert(error.message)
        }
    }

    useEffect(() => {
        getSchCombo();
        getDMTid()
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoader(true);
            if (params?.id) {
                
                const response = await getbbpscommagId(params.id);
                setFormValues2({ name: response.data.name, service_id: response.data.service_id, is_active: response.data.is_active })
                curencyidget(response.data.service_id)
                const clone = { commision_list: response.data.commision_list }
                for (const key in clone) {
                  for (let i = 0; i < clone[key].length; i++) {
                    const element = clone[key][i];
                    if (element.operator_id?.length > 0) {
                        element.operator_id = element.operator_id.map((item) => {
                            return {...item , value: item.name, label: item.name }
                        })
                        
                    }
                  }
                }
                setMainForms({ commision_list: response.data.commision_list })
            } else {
                setMainForms({
                    name: '',
                    service_id: '',
                    isActive: false,
                    commision_list: [
                        {
                            isDefault: true,
                            slots: [
                                {
                                    start_amt: '',
                                    end_amt: '',
                                    charge: '',
                                    charge_type: '',
                                    commision: '',
                                    commision_type: '',
                                    distributor_comm: '',
                                    distributor_comm_type: '',
                                    master_distributer_com: '',
                                    master_distributer_com_type :'',
                                    vendor_commission: [
                                        {
                                          vendor_Id: '',
                                          vendor_com: '',
                                          vendor_com_type: '',
                                          vendor_charge: '',
                                          vendor_charge_type: ''
                                        }
                                      ]
                                }
                            ]
                        }
                    ]
                });
            }
            setLoader(false);
        };
        fetchData();
    }, [params?.id]);

    const removeItem = (index, index1) => {
        const updatedFormValues = { ...mainForms }
        updatedFormValues.commision_list[index1].slots.splice(index, 1)
        setMainForms(updatedFormValues)

    };

    
    const addMoreMain = () => {
        const clone = { ...mainForms }
        clone.commision_list.push({
          isDefault: false,
          operator_id: [],
          slots: [
            {
              start_amt: '',
              end_amt: '',
              charge: '',
              charge_type: '',
              commision: '',
              commision_type: '',
              distributor_comm: '',
              distributor_comm_type: '',
              master_distributer_com: '',
              master_distributer_com_type : "",
              vendor_commission: [
                {
                  vendor_Id: '',
                  vendor_com: '',
                  vendor_com_type: '',
                  vendor_charge: '',
                  vendor_charge_type: ''
                }
              ]
            }
          ]
        });
        setMainForms(clone);
      };

    // const addMoreMain = () => {
    //     const clone = { ...mainForms }
    //     clone.commision_list.push({
    //         isDefault: false,
    //         operator_id: [],
    //         slots: [
    //             {
    //                 start_amt: '',
    //                 end_amt: '',
    //                 charge: '',
    //                 charge_type: '',
    //                 commision: '',
    //                 commision_type: '',
    //                 distributor_comm: '',
    //                 distributor_comm_type: '',
    //                 master_distributer_com: '',
    //             }
    //         ]
    //     })
    //     setMainForms(clone);
    // }
    const removeItemMain = (index) => {
        const updatedFormValues = { ...mainForms }
        updatedFormValues.commision_list.splice(index, 1)
        setMainForms(updatedFormValues)
    }

    const [DataModule, setDataModule] = useState(null)

    const curencyidget = async (id) => {
        try {
            const res = await getdmtcomm3({ start_date: null, end_date: null, service_id: id, page: 0, count: 100 });
            const maped = res?.data?.map((item) => {
                return { ...item, value: item.name, label: item.name }
            })
            setDataModule(maped)

        } catch (error) {
            // alert(error.message)
        }
    }
  
    const handleInputChangeNew = (e, index) => {
        const { name, value, type, checked } = e.target;
        setFormValues2(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
        curencyidget(value)
        setErrors((pre)=>({...pre , [name]:''}))
        // setIsFormValid(checkFormValidity());
    };

    // const checkFormValidity = () => {
    //     // Check if name and service_id are filled
    //     if (!formValues2.name || !formValues2.service_id) return false;
      
    //     // Check if all slots in all commission lists are filled
    //     for (const commissionList of mainForms.commision_list) {
    //       for (const slot of commissionList.slots) {
    //         if (Object.values(slot).some(value => value === '') || slot.vendor_commission.some(val => Object.values(val).some((v)=> v===''))) return false;
    //       }
    //       // Check if operator_id is filled for non-default lists
    //       if (!commissionList.isDefault && (!commissionList.operator_id || commissionList.operator_id.length === 0)) return false;
    //     }
      
    //     return true;
    //   };


      const checkFormValidity = () => {
        const errors = {};
      
        // Global fields
        if (formValues2.name === '') {
          errors.name = "Scheme Name is required";
        }
      
        if (formValues2.service_id === '') {
          errors.service_id = "Service is required";
        }
        if (formValues2.isActive === '') {
          errors.isActive = "Service Status is required";
        }
      
        // Commission List
        mainForms.commision_list.forEach((commissionList, listIndex) => {
          commissionList.slots.forEach((slot, slotIndex) => {
            // Common Fields
            if (slot.start_amt ==='') errors[`start_amt_${listIndex}_${slotIndex}`] = "From Amount is required";
            if (slot.end_amt ==='') errors[`end_amt_${listIndex}_${slotIndex}`] = "To Amount is required";
            if (slot.charge ==='') errors[`charge_${listIndex}_${slotIndex}`] = "Charges are required";
            if (slot.charge_type ==='') errors[`charge_type_${listIndex}_${slotIndex}`] = "Charges Type is required";
            if (slot.commision ==='') errors[`commision_${listIndex}_${slotIndex}`] = "Retailer Commission is required";
            if (slot.commision_type ==='') errors[`commision_type_${listIndex}_${slotIndex}`] = "Retailer Commission Type is required";
            if (slot.distributor_comm ==='') errors[`distributor_comm_${listIndex}_${slotIndex}`] = "Distributor Commission is required";
            if (slot.distributor_comm_type ==='') errors[`distributor_comm_type_${listIndex}_${slotIndex}`] = "Distributor Commission Type is required";
            if (slot.master_distributer_com ==='') errors[`master_distributer_com_${listIndex}_${slotIndex}`] = "Super Distributor Commission is required";
            if (slot?.master_distributer_com_type ==='') errors[`master_distributer_com_type_${listIndex}_${slotIndex}`] = "Super Distributor Commission Type is required";
             
            
      
            // Vendor Commission Loop
            slot.vendor_commission.forEach((vendor, vendorIndex) => {
              if (vendor.vendor_Id ==='') errors[`vendor_Id_${listIndex}_${slotIndex}_${vendorIndex}`] = "Vendor is required";
              if (vendor.vendor_charge ==='') errors[`vendor_charge_${listIndex}_${slotIndex}_${vendorIndex}`] = "Vendor Charges are required";
              if (vendor.vendor_charge_type ==='') errors[`vendor_charge_type_${listIndex}_${slotIndex}_${vendorIndex}`] = "Vendor Charge Type is required";
              if (vendor.vendor_com ==='') errors[`vendor_com_${listIndex}_${slotIndex}_${vendorIndex}`] = "Vendor Commission is required";
              if (vendor.vendor_com_type ==='') errors[`vendor_com_type_${listIndex}_${slotIndex}_${vendorIndex}`] = "Vendor Commission Type is required";
            });
          });
      
          // Operator ID (if not default)
          if (!commissionList.isDefault && (!commissionList.operator_id || commissionList.operator_id.length === 0)) {
            errors[`operator_id_${listIndex}`] = "Operator is required";
          }
        });
      
        setErrors(errors);
        console.log(formValues2 , "formvalue2")
        console.log(errors , "errors")
        return Object.keys(errors).length === 0;
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        if (!checkFormValidity()) return;

     
        setLoader(true);
        const clone = { ...mainForms, name: formValues2.name, service_id: formValues2.service_id, is_active: formValues2.isActive }

        console.log(clone);
        let res;
        if (!params?.id) {
            res = await addBbpsPost(clone);
        } else {
            res = await updateBbpscommagId(params.id, clone);
        }

        if (res.statusCode == 200) {
            toastSuccessMessage();
            setTimeout(() => {
                navigate('/admin/bbps-commision');
            }, 2000);
            setLoader(false);
        } else {
            toastErrorMessage();
            setLoader(false);
        }
    };
         
      const handleChange = (e, index, index1) => {
        const { name, value } = e.target;
        const updatedFormValues = { ...mainForms }
        updatedFormValues.commision_list[index1].slots[index][name] = value;
        setMainForms(updatedFormValues);
        const errorKey = `${name}_${index1}_${index}`;

        // Clear the specific error
        setErrors((prev) => {
          const updatedErrors = { ...prev };
          delete updatedErrors[errorKey];
          return updatedErrors;
        });
        // setIsFormValid(checkFormValidity());

    };
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormValues2(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
        setErrors((pre)=>({...pre , [name]:''}))
        // setIsFormValid(checkFormValidity());
    };
    const handleModuleChange = (selectedOptions, index) => {


        const updatedFormValues = { ...mainForms }
        updatedFormValues.commision_list[index].operator_id = selectedOptions
        setMainForms(updatedFormValues);
         // Construct the dynamic key to clear
  const errorKey = `operator_id_${index}`;

 

  setErrors((prev) => {
    const updatedErrors = { ...prev };
     updatedErrors[errorKey] = '';
    return updatedErrors;
  });
        // setErrors((pre)=>({...pre , pre.commision_list_[index].operator_id:''}))
        // setIsFormValid(checkFormValidity());
    };

      useEffect(() => {
        // setIsFormValid(checkFormValidity());
      }, [mainForms, formValues2])

   // add new code here 
    // add new commission setting for dmt/banktransfer
     const [vendorList, setVendorList] = useState([]);
   
     useEffect(() => {
       const fetchBBPSVendor = async () => {
         try {
           let res = await serviceMasterVendorforbbps();
           if (res?.statusCode == 200) {
             setVendorList(res?.data);
           } else {
             setVendorList([]);
           }
         } catch (error) {}
       };
   
       fetchBBPSVendor();
     }, []);

      const handleVendorCommissionChange = (name , value , slotIndex, listIndex, vendorIndex) => {
        const clone = { ...mainForms };
        clone.commision_list[listIndex].slots[slotIndex].vendor_commission[vendorIndex][name] = value;
        setMainForms(clone);
        const errorKey = `${name}_${listIndex}_${slotIndex}_${vendorIndex}`;

        // Clear the specific error
        setErrors((prev) => {
          const updatedErrors = { ...prev };
          delete updatedErrors[errorKey];
          return updatedErrors;
        });
        // setIsFormValid(checkFormValidity());
      };

      const addVendorCommission = (slotIndex, listIndex) => {
        const clone = { ...mainForms };
        clone.commision_list[listIndex].slots[slotIndex].vendor_commission.push({
          vendor_Id: '',
          vendor_com: '',
          vendor_com_type: '',
          vendor_charge: '',
          vendor_charge_type: '',
        });
        setMainForms(clone);
      };

      const removeVendorCommission = (slotIndex, listIndex, vendorIndex) => {
        const clone = { ...mainForms };
        clone.commision_list[listIndex].slots[slotIndex].vendor_commission.splice(
          vendorIndex,
          1
        );
        setMainForms(clone);
      };

    return (
        <>
            <Breadcrumbs breadCrumbsTitle={""} />
            <ToastContainer />
            {loader? <Loadar /> : null}
            
            <div className="row m-4">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="table-responsive active-projects style-1">
                                <div className="tbl-caption tbl-caption-2">
                                    <h4 className="heading mb-0"><b>{params?.id ? "UPDATE" : "ADD"} BBPS Commission Scheme </b></h4>
                                </div>


                                {mainForms?.commision_list?.map((item, index1) => {
                                    return <div className='mainForm card' key={index1}>
                                        {index1 !== 0 && <IoIosCloseCircleOutline style={{ fontSize: "22px", color: "red", cursor: "pointer" }} onClick={() => removeItemMain(index1)} />}

                                        <form className="form-container" style={{ padding: "20px 0", margin: "0 20px" }} >

                                            {index1 == 0 ? <div className="row" >

                                                <div className="col-xl-4 mb-3">
                                                    <CustomInputField
                                                        type="text"
                                                        value={formValues2.name}
                                                        placeholder="Name"
                                                        name="name"
                                                        onChange={handleInputChange}
                                                        hasError={errors[`name`]}
                                                        errorMsg={errors[`name`]}
                                                    />
                                                </div>
                                                <div className='col-xl-4 mb-3'>
                                                    <select 
                                                    
                                                    className={`form-select ${errors[`service_id`] ? 'is-invalid' : ''}`}
                                                     aria-label="Default select example" id="service_id" name="service_id"
                                                        defaultValue={formValues2?.service_id} onChange={handleInputChangeNew} value={formValues2?.service_id}>
                                                        <option value={''}> select service</option>
                                                        {stateServices && stateServices?.map((item) => {
                                                            return <option value={item?.id}>{item?.service_name}</option>
                                                        })}
                                                    </select>
                                                    {errors[`service_id`] && (
  <div className="invalid-feedback d-block">
    {errors[`service_id`]}
  </div>
)}
                                                </div>


                                                <div className="col-xl-4 mb-3">
                                                    <select
                                                        
                                                        className={`form-select ${errors[`isActive`] ? 'is-invalid' : ''}`}
                                                        aria-label="Default select example"
                                                        name="isActive"
                                                        value={formValues2.isActive}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Status</option>
                                                        <option value={true}>Active</option>
                                                        <option value={false}>Inactive</option>
                                                    </select>
                                                    {errors[`isActive`] && (
  <div className="invalid-feedback d-block">
    {errors[`isActive`]}
  </div>
)}
                                                </div>


                                            </div> : <div className="row" >

                                                <div className="col-xl-4 mb-3">
                                                    <Select
                                                        id="selectModule"
                                                        closeMenuOnSelect={false}
                                                        
                                                        className={`multi-select-set ${errors[`operator_id_${index1}`] ? 'is-invalid' : ''}`}
                                                        isMulti
                                                        options={DataModule}
                                                        value={item?.operator_id}
                                                        // onChange={handleModuleChange}
                                                        onChange={(e) => { handleModuleChange(e, index1) }}
                                                    />
                                                          {errors[`operator_id_${index1}`] && (
  <div className="invalid-feedback d-block">
    {errors[`operator_id_${index1}`]}
  </div>
)}
                                                </div>
                                                {/* <div className="col-xl-4 mb-3">
                                                    <select
                                                        className="form-select"
                                                        aria-label="Default select example"
                                                        name="isDefault"
                                                        value={index1 == 0 ? true : item.isDefault}
                                                        onChange={(e) => handleChange(e, index1)}
                                                    >
                                                        <option value="">Is Default</option>
                                                        <option value="true">Active</option>
                                                        <option value="false">In Active</option>
                                                    </select>
                                                </div> */}




                                            </div>}




                                        </form>
                                        <form className="tbl-captionn" onSubmit={handleSubmit}>
                                            {item?.slots && item?.slots?.map((item, index) => (
                                                <>
                                                
                                                <div className="row" key={index} style={{ border: "1px solid #ccc", padding: "10px 0", margin: "10px 0" }}>

                                                    <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="number"
                                                            value={item.start_amt}
                                                            hasError={errors[`start_amt_${index1}_${index}`]}
                                                            onChange={(e) => handleChange(e, index, index1)}
                                                            errorMsg={errors[`start_amt_${index1}_${index}`]}
                                                            id={`start_amt_${index}`}
                                                            placeholder="From Amount"
                                                            name="start_amt"
                                                        />
                                                    </div>
                                                    <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="number"
                                                            value={item.end_amt}
                                                            hasError={errors[`end_amt_${index1}_${index}`]}
                                                            onChange={(e) => handleChange(e, index, index1)}
                                                            errorMsg={errors[`end_amt_${index1}_${index}`]}
                                                            id={`end_amt_${index}`}
                                                            placeholder="To Amount"
                                                            name="end_amt"
                                                        />
                                                    </div>
                                                    <div className="col-xl-2 mb-3">
                                                        <CustomInputField
                                                            type="number"
                                                            value={item.charge}
                                                            hasError={errors[`charge_${index1}_${index}`]}
                                                            onChange={(e) => handleChange(e, index, index1)}
                                                            errorMsg={errors[`charge_${index1}_${index}`]}
                                                            id={`charge_${index}`}
                                                            placeholder="Charges"
                                                            name="charge"
                                                        />
                                                    </div>
                                                    <div className="col-xl-2 mb-3">
                                                        <select
                                                           
                                                            className={`form-select ${errors[`charge_type_${index1}_${index}`] ? 'is-invalid' : ''}`}
                                                            aria-label="Default select example"
                                                            id={`charge_type_${index}`}
                                                            name="charge_type"
                                                            value={item.charge_type}
                                                            onChange={(e) => handleChange(e, index, index1)}
                                                        >
                                                            <option value="">Charges type</option>
                                                            <option value="Percent">%</option>
                                                            <option value="Flat">RS</option>
                                                        </select>
                                                        {errors[`charge_type_${index1}_${index}`] && (
  <div className="invalid-feedback d-block">
    {errors[`charge_type_${index1}_${index}`]}
  </div>
)}
                                                    </div>
                                                    <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="number"
                                                            value={item.commision}
                                                            hasError={errors[`commision_${index1}_${index}`]}
                                                            onChange={(e) => handleChange(e, index, index1)}
                                                            errorMsg={errors[`commision_${index1}_${index}`]}
                                                            id={`commision_${index}`}
                                                            placeholder="R Commission"
                                                            name="commision"
                                                        />
                                                    </div>
                                                    <div className="col-xl-4 mb-3">
                                                        <select
                                                           
                                                            className={`form-select ${errors[`commision_type_${index1}_${index}`] ? 'is-invalid' : ''}`}
                                                            aria-label="Default select example"
                                                            id={`commision_type${index}`}
                                                            name="commision_type"
                                                            value={item.commision_type}
                                                            onChange={(e) => handleChange(e, index, index1)}
                                                        >
                                                            <option value="">R commission type</option>
                                                            <option value="Percent">%</option>
                                                            <option value="Flat">RS</option>
                                                        </select>
                                                        {errors[`commision_type_${index1}_${index}`] && (
  <div className="invalid-feedback d-block">
    {errors[`commision_type_${index1}_${index}`]}
  </div>
)}
                                                    </div>
                                                    <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="number"
                                                            value={item.distributor_comm}
                                                            hasError={errors[`distributor_comm_${index1}_${index}`]}
                                                            onChange={(e) => handleChange(e, index, index1)}
                                                            errorMsg={errors[`distributor_comm_${index1}_${index}`]}
                                                            id={`distributor_comm_${index}`}
                                                            placeholder="Dist Commission"
                                                            name="distributor_comm"
                                                        />
                                                    </div>
                                                    <div className="col-xl-4 mb-3">
                                                        <select
                                                           className={`form-select ${errors[`distributor_comm_type_${index1}_${index}`] ? 'is-invalid' : ''}`}
                                                            aria-label="Default select example"
                                                            id={`distributor_comm_type_${index}`}
                                                            name="distributor_comm_type"
                                                            value={item.distributor_comm_type}
                                                            onChange={(e) => handleChange(e, index, index1)}
                                                        >
                                                            <option value="">Dist Commission type</option>
                                                            <option value="Percent">%</option>
                                                            <option value="Flat">RS</option>
                                                        </select>
                                                        {errors[`distributor_comm_type_${index1}_${index}`] && (
  <div className="invalid-feedback d-block">
    {errors[`distributor_comm_type_${index1}_${index}`]}
  </div>
)}
                                                    </div>
                                                    <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="number"
                                                            value={item.master_distributer_com}
                                                            hasError={errors[`master_distributer_com_${index1}_${index}`]}
                                                            onChange={(e) => handleChange(e, index, index1)}
                                                            errorMsg={errors[`master_distributer_com_${index1}_${index}`]}
                                                            id={`master_distributer_com_${index}`}
                                                            placeholder="S Dist Commission"
                                                            name="master_distributer_com"
                                                        />
                                                    </div>
                                                    <div className="col-xl-4 mb-3">
                                                        <select
                                                            
                                                            className={`form-select ${errors[`master_distributer_com_type_${index1}_${index}`] ? 'is-invalid' : ''}`}
                                                            aria-label="Default select example"
                                                            id={`master_distributer_com_type_${index}`}
                                                            name="master_distributer_com_type"
                                                            value={item.master_distributer_com_type}
                                                            onChange={(e) => handleChange(e, index, index1)}
                                                        >
                                                            <option value="">S Dist Commission type</option>
                                                            <option value="Percent">%</option>
                                                            <option value="Flat">RS</option>
                                                        </select>
                                                        {errors[`master_distributer_com_type_${index1}_${index}`] && (
  <div className="invalid-feedback d-block">
    {errors[`master_distributer_com_type_${index1}_${index}`]}
  </div>
)}
                                                    </div>


                                                 
                                                
                                                <div key={`${index1}-${index}`} className="row">
      {item?.vendor_commission?.map((vendor, vendorIndex) => (
        <React.Fragment key={vendorIndex}>
          <div className="col-xl-4 mb-3">
            <select
             
              className={`form-select ${errors[`vendor_Id_${index1}_${index}_${vendorIndex}`] ? 'is-invalid' : ''}`}
              value={vendor.vendor_Id}
              onChange={(e) =>
                handleVendorCommissionChange(
                  'vendor_Id',
                  e.target.value,
                  index,
                  index1,
                  vendorIndex
                )
              }
            >
              <option value="" disabled>
                Vendor List
              </option>
              {vendorList?.map((v) => (
                <option value={v?._id} key={v?._id}>
                  {v?.slug}
                </option>
              ))}
            </select>
            {errors[`vendor_Id_${index1}_${index}_${vendorIndex}`] && (
  <div className="invalid-feedback d-block">
    {errors[`vendor_Id_${index1}_${index}_${vendorIndex}`]}
  </div>
)}
          </div>
          <div className="col-xl-4 mb-3">
            <input
              type="number"
              
              className={`form-control ${errors[`vendor_charge_${index1}_${index}_${vendorIndex}`] ? 'is-invalid' : ''}`}
              value={vendor.vendor_charge}
              onChange={(e) =>
                handleVendorCommissionChange(
                  'vendor_charge',
                  e.target.value,
                  index,
                  index1,
                  vendorIndex
                )
              }
              placeholder="Vendor Charges"
            />
                   {errors[`vendor_charge_${index1}_${index}_${vendorIndex}`] && (
  <div className="invalid-feedback d-block">
    {errors[`vendor_charge_${index1}_${index}_${vendorIndex}`]}
  </div>
)}
          </div>
          <div className="col-xl-4 mb-3">
            <select
           
              className={`form-select ${errors[`vendor_charge_type_${index1}_${index}_${vendorIndex}`] ? 'is-invalid' : ''}`}
              value={vendor.vendor_charge_type}
              onChange={(e) =>
                handleVendorCommissionChange(
                  'vendor_charge_type',
                  e.target.value,
                  index,
                  index1,
                  vendorIndex
                )
              }
            >
              <option value="">Vendor Charge type</option>
              <option value="Percent">%</option>
              <option value="Flat">RS</option>
            </select>
            {errors[`vendor_charge_type_${index1}_${index}_${vendorIndex}`] && (
  <div className="invalid-feedback d-block">
    {errors[`vendor_charge_type_${index1}_${index}_${vendorIndex}`]}
  </div>
)}
          </div>
          <div className="col-xl-4 mb-3">
            <input
              type="number"
            
              className={`form-control ${errors[`vendor_com_${index1}_${index}_${vendorIndex}`] ? 'is-invalid' : ''}`}
              value={vendor.vendor_com}
              onChange={(e) =>
                handleVendorCommissionChange(
                  'vendor_com',
                  e.target.value,
                  index,
                  index1,
                  vendorIndex
                )
              }
              placeholder="Vendor Commission"
            />
                 {errors[`vendor_com_${index1}_${index}_${vendorIndex}`] && (
  <div className="invalid-feedback d-block">
    {errors[`vendor_com_${index1}_${index}_${vendorIndex}`]}
  </div>
)}
          </div>
          <div className="col-xl-4 mb-3">
            <select
             
              className={`form-select ${errors[`vendor_com_type_${index1}_${index}_${vendorIndex}`] ? 'is-invalid' : ''}`}
              value={vendor.vendor_com_type}
              onChange={(e) =>
                handleVendorCommissionChange(
                  'vendor_com_type',
                  e.target.value,
                  index,
                  index1,
                  vendorIndex
                )
              }
            >
              <option value="">Vendor Commission Type</option>
              <option value="Percent">%</option>
              <option value="Flat">RS</option>
            </select>
            {errors[`vendor_com_type_${index1}_${index}_${vendorIndex}`] && (
  <div className="invalid-feedback d-block">
    {errors[`vendor_com_type_${index1}_${index}_${vendorIndex}`]}
  </div>
)}
          </div>
          <div className="col-4 mb-3">
  <div className="d-flex gap-1 align-items-center">
    <button
      className="btn btn-primary"
      type="button"
      onClick={() => addVendorCommission(index , index1)}
    >
      Add New
    </button>

    {vendorIndex !== 0 && (
      <button
        className="btn btn-danger"
        type="button"
        onClick={() => removeVendorCommission(index, index1 , vendorIndex)}
      >
        Remove
      </button>
    )}
  </div>
</div>
        </React.Fragment>
      ))}
      </div>
      {index !== 0 && (
                                                        <div className="col-xl-4 mb-3">
                                                            <button
                                                                className="btn btn-danger"
                                                                type="button"
                                                                onClick={(e) => removeItem(index, index1)}
                                                            >
                                                                Remove
                                                            </button>
                                                        </div>
                                                    )}

      </div>
               
                                                </>

                                            ))}
                                          <div className="d-flex justify-content-between mt-4 mb-4">
                                                <button
                                                    className="btn btn-secondary"
                                                    type="button"
                                                    onClick={() => { addMore(index1) }}
                                                >
                                                    Add More Slot
                                                </button>


                                            </div>
                                        </form>

                                    </div>
                                })}

                                <div>


                                    <button
                                        className="btn btn-secondary"
                                        type="button"
                                        onClick={addMoreMain}
                                    >
                                        Add More
                                    </button>

                                    <button
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={handleSubmit}
                                        // disabled={!isFormValid}
                                    >
                                        {params?.id ? "Update" : "Save"}
                                    </button>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BbpsCommisionForm;